import React from "react";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

class StudentSignUp extends React.Component {
    constructor() {
        super();
        this.recaptchaRef = React.createRef();

        this.state = {
            captcha: false,
            fullName: '',
            email: '',
            studentClass: '',
            phone: '',
            dob: '',
            password: '',
            confirmPassword: '',
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChangeCaptcha = (value) => {
        this.setState({
            captcha: true
        })
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        const { password, confirmPassword } = this.state;
        // perform all neccassary validations
        if (password !== confirmPassword) {
            toast.error("Password doesn't match", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        } else if (!this.state.captcha) {
            toast.error("Please complete the captcha verification", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
        }
        else {

            // get our form data out of state
            const {
                fullName,
                email,
                studentClass,
                phone,
                dob,
                password,
            } = this.state;
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    fullName,
                    email,
                    class: studentClass,
                    phone,
                    dob,
                    password,
                })
            };
            let url = "http://15.206.132.121:3002/api/registerStudent";
            return fetch(url, requestOptions)
                .then(response => response.json())
                .then((res) => {
                    if (!res.success) {
                        throw res.message
                    }
                    window.alert(`Please note your registration number  ${res.data.GeneratedRegistrationNumber}. An email verification link is sent to your email ID.`)
                    this.props.history.push('/')
                })
                .catch(err =>
                    toast.error("Student SignUp Failed", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    })
                );
        }


    }


    render() {
        const {
            fullName,
            email,
            studentClass,
            phone,
            dob,
            password,
            confirmPassword,
        } = this.state;
        return (
            <div className="container">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <form className="form-signin" onSubmit={this.handleSubmit}>

                    <h2 className="form-signin-heading">registration</h2>
                    <div className="login-wrap">
                        <p>Enter your details below</p>
                        <input type="text" className="form-control" placeholder="Full Name" name="fullName" value={fullName} required onChange={this.onChange} />
                        <input type="email" className="form-control" placeholder="Email" name="email" value={email} required onChange={this.onChange} />
                        <input type="text" className="form-control" placeholder="Class" name="studentClass" value={studentClass} required onChange={this.onChange} />
                        <input type="date" className="form-control" placeholder="Date of Birth" name="dob" value={dob} required onChange={this.onChange} />
                        <input type="number" className="form-control" placeholder="Phone Number" name="phone" value={phone} required onChange={this.onChange} />
                        <input type="password" className="form-control" placeholder="Password" name="password" value={password} required onChange={this.onChange} />
                        <input type="password" className="form-control" placeholder="ConfirmPassword" name="confirmPassword" value={confirmPassword} required onChange={this.onChange} />
                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            sitekey="6LeWyqUZAAAAAJJJqKWK4tcs5dvjU_C9YwHqrbFX"
                            onChange={this.onChangeCaptcha}
                        />

                        <button className="btn btn-lg btn-login btn-block" type="submit">Submit</button>

                        <div className="registration">
                            Already Registered.
                            <Link to={{ pathname: "/" }} > Sign In </Link>
                        </div>

                    </div>

                </form>

            </div>
        )
    }
}

function mapStateToProps(state) {
    let student = state.studentLogin.student
        ? state.studentLogin.student.data
        : {};

    return {
        student,
    };
}

const connectedStudentPage = connect(mapStateToProps)(StudentSignUp);
export { connectedStudentPage as StudentSignUp };